import { Button } from "components/Button";
import styled, { css } from "styled-components";
import bolas from "../../assets/images/bolas.svg";

export const Container = styled.div``;

export const IntroductionContainer = styled.div`
  height: 100vh;
  width: 75%;

  @media (max-width: 970px) {
    width: 100%;
  }
`;

export const IntroductionWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colors.primary};
    background-image: url(${bolas});
    background-repeat: no-repeat;
    background-position: bottom left;

    height: 100%;
    border-radius: 0 0 50% 0;

    div {
      padding-top: 14.3125rem;
      padding-left: 4.5rem;
    }
  `}
`;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.light_text};
    font-size: 2.5rem;
    line-height: 3.5625rem;
    margin-bottom: 2.5rem;

    @media (max-width: 770px) {
      font-size: 2rem;
    }

    @media (max-width: 425px) {
      font-size: 1.6rem;
    }

    @media (max-width: 350px) {
      font-size: 1.4rem;
    }
  `}
`;

export const ChoiceThePropertyImage = styled.img`
  height: 36.5rem;
  width: 32.875rem;
  position: absolute;
  right: 11.2%;
  top: 6.0625rem;
  border-radius: 25% 0 25% 25%;

  @media (max-width: 1360px) {
    height: 30.5rem;
    width: 26.875rem;
  }

  @media (max-width: 1350px) {
    display: none;
  }
`;

export const CustomizedButton = styled(Button)`
  background-color: #00443d;
`;
